<template>
  <div class="page-container">
    <div id="searchArea">
      <div class="clearfix">
        <div class="fl pb10">
          <el-button type="primary" @click="addOrUpdateHandle()">Add Currency</el-button>
        </div>
        <div class="fr">
          <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-select v-model="dataForm.currency" placeholder="Currency" clearable filterable>
                <el-option
                  v-for="item in currencyList"
                  :key="`exRate-config-table-${item.currency}`"
                  :label="item.currency"
                  :value="item.currency"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="flex">
                <el-select v-model="dataForm.dateType" class="wd135 controlLeft">
                  <el-option v-for="item in dateTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
                </el-select>
                <el-date-picker
                  value-format="timestamp"
                  v-model="tradeTimeRange"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="Start Time"
                  end-placeholder="End Time"
                  class="controlRight"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-table
        max-height="680"
        v-loading="dataListLoading"
        :data="dataList"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column label="Currency Code" prop="currency" align="center" />
        <el-table-column label="Currency Symbol" prop="symbol" align="center" />
        <el-table-column label="Basis Amount" prop="exchangeRateBasis" align="center" />
        <el-table-column label="Create Time" prop="createTime" align="center" width="180" sortable="custom" />
        <el-table-column label="Update Time" prop="updateTime" align="center" width="180" />
        <el-table-column label="Action" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" @update="update" />
  </div>
</template>

<script>
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import ElDatePickerRange from "@/components/ElDatePickerRange";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import { mapActions, mapState } from "vuex";
export default {
  mixins: [paginationMixin, tableMixin],
  components: {
    ElDatePickerRange,
    AddOrUpdateDialog,
    Pagination,
  },
  data() {
    return {
      dateTypes: [
        {
          title: "Create Time",
          value: "createTime",
        },
        {
          title: "Update Time",
          value: "updateTime",
        },
      ],
      dataForm: {
        currency: [],
        dateType: "createTime",
        createTimeStart: "",
        createTimeEnd: "",
        updateTimeStart: "",
        updateTimeEnd: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      tradeTimeRange: null,
      dataList: [],
      dataListLoading: false,
    };
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
  },
  watch: {
    tradeTimeRange(newValue, oldValue) {
      if (newValue) {
        if (this.dataForm.dateType == "createTime") {
          this.dataForm.createTimeStart = newValue[0];
          this.dataForm.createTimeEnd = newValue[1];
          this.dataForm.updateTimeStart = "";
          this.dataForm.updateTimeEnd = "";
        } else {
          this.dataForm.updateTimeStart = newValue[0];
          this.dataForm.updateTimeEnd = newValue[1];
          this.dataForm.createTimeStart = "";
          this.dataForm.createTimeEnd = "";
        }
      } else {
        this.dataForm.createTimeStart = "";
        this.dataForm.createTimeEnd = "";
        this.dataForm.updateTimeStart = "";
        this.dataForm.updateTimeEnd = "";
      }
    },
  },
  methods: {
    ...mapActions("currency", ["getCurrencyList"]),
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/currency/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this currency. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/currency/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
            // 更新货币(currency)列表
            this.getCurrencyList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
    // 更新
    update() {
      this.getDataList();
      // 更新货币(currency)列表
      this.getCurrencyList();
    },
  },
  activated() {
    // 获取分页数据
    this.getDataList();
    // 更新货币(currency)列表
    this.getCurrencyList();
  },
};
</script>

<style lang="scss" scoped>
.controlLeft {
  ::v-deep input {
    // border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input__inner.is-focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input:focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }

  ::v-deep .el-input.is-focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }
}

.controlRight {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ::v-deep input {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
